import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as subscriptionPackActions from '../../../store/subscription-packs'
import Y from '../../../y18n'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import SubscriptionPacksDropdown from '../../../common/dropdowns/subscription-packs-dropdown'

import Moment from 'moment'

import Sizes from '../../../common/styles/sizes'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscriptionPacks: state.subscriptionPacks
})

const mapDispatchToProps = dispatch => ({
  subscriptionPackActions: bindActionCreators(subscriptionPackActions, dispatch)
})

class EditSubscriptionPackDialog extends Component {
  closeFormDialog = () => {
    this.props.subscriptionPackActions.clearActive()
  }

  // Input changed with KEY / VALUE
  inputChangedKV = name => e => {
    this.props.subscriptionPackActions.updateActive(name, e.target.value)
  }

  inputChangedSubpack = name => e => {
    for(var i = 0; i < this.props.subscriptionPacks.items.length; i++){
      if(this.props.subscriptionPacks.items[i].id === e.target.value)
        this.props.subscriptionPackActions.updateActive(name, this.props.subscriptionPacks.items[i]);
    }
  }

  submitChanges = (e, subPack) => {
    e.preventDefault()
    if(this.props.subscriptionPacks && this.props.subscriptionPacks.currentState.new && subPack)
      this.props.subscriptionPackActions.createSubscriptionPack(subPack)
    else if (this.props.subscriptionPacks && this.props.subscriptionPacks.active && this.props.subscriptionPacks.currentState.edit && subPack)
      this.props.subscriptionPackActions.updateSubscriptionPack(subPack)
    this.props.subscriptionPackActions.toggleDialog()
  }

  render () {
    const { subscriptionPacks, subscriptionPackActions, classes } = this.props
    if(!subscriptionPacks || !subscriptionPacks.active || (!subscriptionPacks.currentState.edit && !subscriptionPacks.currentState.new)) return null
    
    return (
      <div>
        <Dialog
        open={subscriptionPacks.currentState.edit || subscriptionPacks.currentState.new}
        onClose={() => this.closeFormDialog()}
        classes={{
          paper: classes.dialogContent
        }}
        >
        <form onSubmit={e => this.submitChanges(e, subscriptionPacks.active)}>

        {subscriptionPacks.currentState.new ? null : 
            <div className={classes.dialogHeaderContent}>
              <DialogTitle style={{display: 'flex'}}>{subscriptionPacks.new === true ? Y`subpack_create_page` : Y`subpack_edit_page`}</DialogTitle>
              <Button onClick={() => subscriptionPackActions.deleteSubscriptionPack(subscriptionPacks.active.id)} variant='raised' className={classes.dialogTitleDeleteBtn} style={{color:'#fff'}}>
              {Y`Delete`}
              </Button>
            </div>
        }
          
          <DialogContent>
            <TextField
              margin='normal'
              label={Y`Name`}
              type='text'
              value={subscriptionPacks.active ? subscriptionPacks.active.name : ''}
              onChange={this.inputChangedKV('name')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              fullWidth
              required
            />

            <TextField
              margin='normal'
              label={Y`subpack_tags`}
              type='text'
              value={subscriptionPacks.active ? subscriptionPacks.active.tags : ''}
              onChange={this.inputChangedKV('tags')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              fullWidth
            />

            <TextField
              margin='normal'
              label={Y`Data pack ID`}
              type='text'
              value={subscriptionPacks.active ? subscriptionPacks.active.dataPackId : ''}
              onChange={this.inputChangedKV('dataPackId')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              fullWidth
              required
            />

            <TextField
              margin='normal'
              label={Y`Sms pack ID`}
              type='text'
              value={subscriptionPacks.active ? subscriptionPacks.active.smsPackId : ''}
              onChange={this.inputChangedKV('smsPackId')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              fullWidth
              required
            />

            <TextField
              margin='normal'
              label={Y`subpack_data_limit`}
              type='number'
              value={subscriptionPacks.active ? subscriptionPacks.active.data : 0}
              onChange={this.inputChangedKV('data')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              fullWidth
              required
            />
            <div className={classes.flexRow}>
              <TextField
                style={{width: Sizes.textfieldWidth}}
                margin='normal'
                label={Y`subpack_downgrade_limit`}
                type='number'
                value={(subscriptionPacks.active && subscriptionPacks.active.downgradeLimit) || 0}
                onChange={this.inputChangedKV('downgradeLimit')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
              />
              <TextField
                style={{width: Sizes.textfieldWidth}}
                margin='normal'
                label={Y`subpack_upgrade_limit`}
                type='number'
                value={(subscriptionPacks.active && subscriptionPacks.active.upgradeLimit) || 0}
                onChange={this.inputChangedKV('upgradeLimit')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
              />
            </div>
            <div className={classes.flexRow}>
                
            </div>
            <div className={classes.flexRow}>
                <SubscriptionPacksDropdown
                  value={((subscriptionPacks.active && subscriptionPacks.active.downgradeTo && subscriptionPacks.active.downgradeTo.name) || '')}
                  label={Y`subpack_downgrade_to`}
                  handleChange={this.inputChangedSubpack('downgradeTo')}
                  fullWidth={false}
                  required={!subscriptionPacks.currentState.new && subscriptionPacks.active.downgradeLimit > 0 ? true : false}
                />
                <SubscriptionPacksDropdown
                  value={( (subscriptionPacks.active && subscriptionPacks.active.upgradeTo && subscriptionPacks.active.upgradeTo.name) || '') }
                  label={Y`subpack_upgrade_to`}
                  handleChange={this.inputChangedSubpack('upgradeTo')}
                  fullWidth={false}
                  required={!subscriptionPacks.currentState.new && subscriptionPacks.active.upgradeLimit > 0 ? true : false}
                />
            </div>
            {subscriptionPacks.new ? null :
            <div>

              <div className={classes.flexRow}>
                <TextField
                  style={{width: Sizes.textfieldWidth}}
                  margin='normal'
                  label={Y`subpack_created_date`}
                  type='text'
                  value={subscriptionPacks.active && subscriptionPacks.active.creationDate ? Moment.utc(subscriptionPacks.active.creationDate).local().format('YYYY-MM-DD HH:mm:ss') : ''}
                  disabled={true}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />

                <TextField
                  style={{width: Sizes.textfieldWidth}}
                  margin='normal'
                  label={Y`subpack_edited_date`}
                  type='text'
                  value={subscriptionPacks.active && subscriptionPacks.active.edited ? Moment.utc(subscriptionPacks.active.edited).local().format('YYYY-MM-DD HH:mm:ss') : ''}
                  disabled={true}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />
              </div>
              <div className={classes.flexRow}>
                <TextField
                  style={{width: Sizes.textfieldWidth}}
                  margin='normal'
                  label={Y`subpack_created_by`}
                  type='text'
                  value={subscriptionPacks.active && subscriptionPacks.active.createdBy ? subscriptionPacks.active.createdBy : 'NULL?'}
                  disabled={true}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />

                <TextField
                  style={{width: Sizes.textfieldWidth}}
                  margin='normal'
                  label={Y`subpack_edited_by`}
                  type='text'
                  value={subscriptionPacks.active && subscriptionPacks.active.editedBy ? subscriptionPacks.active.editedBy : 'NULL?'}
                  disabled={true}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />
              </div>
            </div>
            }

            <DialogActions>
              {subscriptionPacks.currentState.new ? 
                <Button onClick={() => subscriptionPackActions.clearNew()}>{Y`Cancel`}</Button> :
                <Button onClick={() => subscriptionPackActions.clearActive()}>{Y`Cancel`}</Button>
              }
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>

          </DialogContent>
        </form>

        </Dialog>
      </div>
    )
  }

  closeDialog = () => {
    this.props.clearNew()
    this.props.clearActive()
    this.props.subscriptionPackActions.toggleDialog()
  }
}

EditSubscriptionPackDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSubscriptionPackDialog)
export default withStyles(Styles)(EditSubscriptionPackDialog)



// WEBPACK FOOTER //
// ./src/pages/subscription-packs/containers/edit-subscription-pack-dialog.js